export { default } from '@relo/sports-components/es/AccordionTitle';
export * from '@relo/sports-components/es/AccordionTitle';
